var map = {
	"./af-report-icon.svg": 31813,
	"./af.svg": 66686,
	"./afdetected.svg": 29580,
	"./afnotdetected.svg": 12723,
	"./alerton.svg": 55712,
	"./annotations-report-icon.svg": 78592,
	"./app_disconnected.svg": 85630,
	"./arrow-down.svg": 13535,
	"./arrythmia-filter.svg": 77787,
	"./avatar.svg": 82784,
	"./bell.svg": 66876,
	"./blood pressure disabled.svg": 59606,
	"./blood-pressure-report-icon.svg": 65504,
	"./blood_pressure.svg": 85853,
	"./body temp disabled.svg": 51805,
	"./body_temp.svg": 41248,
	"./calander.svg": 78969,
	"./calories.svg": 36351,
	"./check.svg": 87121,
	"./checkbox.svg": 32500,
	"./circle.svg": 72431,
	"./clock.svg": 96347,
	"./common/github.svg": 25614,
	"./common/google.svg": 65282,
	"./configurations.svg": 99894,
	"./countries.svg": 56451,
	"./daily-report-icon.svg": 65701,
	"./edit.svg": 96415,
	"./ellipse.svg": 53391,
	"./events-report-icon.svg": 79007,
	"./expand.svg": 31311,
	"./eye-hide.svg": 35819,
	"./eye-show.svg": 86272,
	"./flag.svg": 55305,
	"./fota.svg": 19639,
	"./generate-unique-id.svg": 61488,
	"./glucose disabled.svg": 65059,
	"./glucose.svg": 55537,
	"./grid-off.svg": 3999,
	"./grid.svg": 33735,
	"./hamburger.svg": 48780,
	"./hide.svg": 94819,
	"./home.svg": 23086,
	"./inbox.svg": 56925,
	"./list-on.svg": 76467,
	"./list.svg": 68855,
	"./medcine_reminder.svg": 38029,
	"./messages.svg": 11899,
	"./monthly-report-icon.svg": 81317,
	"./my_profile.svg": 22167,
	"./next.svg": 15356,
	"./night_respiratory.svg": 22578,
	"./night_rrv.svg": 14324,
	"./notmeasured.svg": 16934,
	"./offwrist.svg": 27587,
	"./pathecg.svg": 76949,
	"./patient_list.svg": 92717,
	"./patient_requests.svg": 26619,
	"./patients.svg": 37617,
	"./pdf.svg": 17603,
	"./physicians.svg": 90580,
	"./pinnedoff.svg": 5944,
	"./pinnedon.svg": 13970,
	"./prev.svg": 55260,
	"./print.svg": 87196,
	"./pulse rate disabled.svg": 20860,
	"./pulse_rate.svg": 70735,
	"./pwv-report-icon.svg": 38089,
	"./reminder_clock.svg": 18814,
	"./remindmelater.svg": 77692,
	"./remove-doctor.svg": 21189,
	"./reports.svg": 4772,
	"./respiratory rate disabled.svg": 55135,
	"./respiratory rate.svg": 5749,
	"./saturation-report-icon.svg": 20880,
	"./search-circle.svg": 20164,
	"./search.svg": 63463,
	"./send-circle.svg": 51518,
	"./show.svg": 54840,
	"./sleep-apnea-report-icon.svg": 40041,
	"./sleep.svg": 78004,
	"./sort.svg": 40631,
	"./sort_list.svg": 65006,
	"./spo2 disabled.svg": 90503,
	"./spo2.svg": 98509,
	"./steps.svg": 41944,
	"./tike.svg": 60038,
	"./timefilter.svg": 26294,
	"./trash.svg": 82571,
	"./versions.svg": 54392,
	"./vi.svg": 26020,
	"./viewers.svg": 55128,
	"./watch_diconnected.svg": 32339,
	"./watches.svg": 26280,
	"./weight disabled.svg": 59773,
	"./weight.svg": 27263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57521;